'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SomeHash$() {
  this.ccU = null;
  this.ccV = false;
  this.ccS = null;
  this.ccT = false;
}
export { $c_Lpresto_types$SomeHash$ as $c_Lpresto_types$SomeHash$ };
$p = $c_Lpresto_types$SomeHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SomeHash$;
/** @constructor */
function $h_Lpresto_types$SomeHash$() {
}
export { $h_Lpresto_types$SomeHash$ as $h_Lpresto_types$SomeHash$ };
$h_Lpresto_types$SomeHash$.prototype = $p;
$p.a38 = (function() {
  if ((!this.ccV)) {
    this.ccU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ccV = true;
  }
  return this.ccU;
});
$p.a34 = (function() {
  if ((!this.ccT)) {
    this.ccS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.ccT = true;
  }
  return this.ccS;
});
var $d_Lpresto_types$SomeHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SomeHash$, "presto.types$SomeHash$", ({
  a2g: 1
}));
export { $d_Lpresto_types$SomeHash$ as $d_Lpresto_types$SomeHash$ };
var $n_Lpresto_types$SomeHash$;
function $m_Lpresto_types$SomeHash$() {
  if ((!$n_Lpresto_types$SomeHash$)) {
    $n_Lpresto_types$SomeHash$ = new $c_Lpresto_types$SomeHash$();
  }
  return $n_Lpresto_types$SomeHash$;
}
export { $m_Lpresto_types$SomeHash$ as $m_Lpresto_types$SomeHash$ };
//# sourceMappingURL=presto.types$-Some-Hash$.js.map
